/* eslint-disable no-unused-expressions */
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { loginAlerts } from '../../constants';
import { useAction } from '../../../Common/hooks';
import { saveSessionToken, setLoginAlert } from '../../actions';
import { getIsLoggedIn, getLoginAlert } from '../../selectors';
import { getSessionToken } from '../../services';

const useLoginForm = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const { isVisible, alertType } = useSelector(getLoginAlert);
  const isLoggedIn = useSelector(getIsLoggedIn);
  const dispatchSaveSessionToken = useAction(saveSessionToken);
  const dispatchAlert = useAction(setLoginAlert);
  const history = useHistory();

  const closeAlertHandler = () => {
    dispatchAlert({ alertType: '', isVisible: false });
  };

  const handleFormSubmission = async e => {
    e.preventDefault();
    const token = await getSessionToken(username, password);
    if (!token) {
      dispatchAlert({ alertType: loginAlerts.errorAlert, isVisible: true });
    }

    dispatchSaveSessionToken({ sessionToken: token });
  };

  useEffect(() => {
    if (isLoggedIn) {
      history.push('/evv/visits');
    }
  }, [isLoggedIn]);

  return {
    setUsername,
    setPassword,
    username,
    password,
    alertType,
    isVisible,
    handleFormSubmission,
    closeAlertHandler,
  };
};

export default useLoginForm;
